module.exports = __webpack_public_path__ + "static/tribalscale-logo-b93dd332734a2778a086e9e48971eaa1.png";